import { Box, Icon, Image, Stack, Text } from '@qcx/ui';
import { Link } from '../../../../components/Link';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';

interface PromoBannerProps {
  imageUrl: string;
  title: string;
  description: string;
  buttonText: string;
  link: string;
}

export const PromoBanner = ({
  imageUrl,
  title,
  description,
  buttonText,
  link
}: PromoBannerProps) => {
  return (
    <Link target="_blank" to={link}>
      <Stack
        css={{
          d: 'none',
          '@sm': {
            d: 'flex'
          },
          alignItems: 'center',
          backgroundColor: '$neutral50',
          p: '$4',
          rounded: '$md'
        }}
      >
        {imageUrl && (
          <Box css={{ w: 140, h: 105 }}>
            <Image
              css={{ marginRight: '$4', borderRadius: '$md' }}
              width={140}
              height={105}
              alt="Promo Image"
              src={imageUrl}
            />
          </Box>
        )}
        <Stack css={{ flex: 1, marginRight: '$4' }} flow="column">
          <Text
            css={{ marginBottom: '$2', color: '$black' }}
            variant="md"
            weight="bold"
          >
            {title}
          </Text>
          <Text css={{ marginBottom: '$2', color: '$black' }} variant="sm">
            {description}
          </Text>
          <Stack
            css={{
              color: '$orangeDark600',
              alignItems: 'center'
            }}
            gap="$2"
          >
            <Text variant="sm">{buttonText}</Text>
            <Icon icon={faChevronRight} />
          </Stack>
        </Stack>
      </Stack>
      <Box
        css={{
          d: 'block',
          '@sm': {
            d: 'none'
          },
          alignItems: 'center',
          backgroundColor: '$neutral50',
          p: '$3',
          rounded: '$md'
        }}
      >
        <Text css={{ color: '$black' }} variant="md" weight="bold">
          {title}
        </Text>
        <Stack css={{ mt: '$2' }} gap="$2">
          <Box css={{ w: 140, h: '105' }}>
            <Image
              css={{ borderRadius: '$md' }}
              width={140}
              height={105}
              alt="Promo Image"
              src={imageUrl}
            />
          </Box>
          <Stack css={{ flex: 1 }} flow="column">
            <Text css={{ marginBottom: '$2', color: '$black' }} variant="sm">
              {description}
            </Text>
          </Stack>
        </Stack>
        <Stack
          css={{
            mt: '$4',
            color: '$orangeDark600',
            alignItems: 'center',
            justifyContent: 'center'
          }}
          gap="$2"
        >
          <Text variant="sm">{buttonText}</Text>
          <Icon icon={faChevronRight} />
        </Stack>
      </Box>
    </Link>
  );
};
